import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";
import type { PartnerMarketingViewModel } from "libs/codegen/property-onboarding/models/partner-marketing-view-model";

export const partnerMarketingModelAtom = atom<PartnerMarketingViewModel>();

export const usePartnerMarketingModelState = () => useAtom(partnerMarketingModelAtom);
export const useSetPartnerMarketingModel = () => useSetAtom(partnerMarketingModelAtom);
export const usePartnerMarketingModelValue = () => useAtomValue(partnerMarketingModelAtom);
